import './HomeForm.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ApplyNew from './HomeForm/ApplyNew';
import ModifyApplication from './HomeForm/ModifyApplication';
import LEIRenewal from './HomeForm/LEIRenewal';
import TransferAnLEI from './HomeForm/TransferAnLEI';
import TrackYourStatus from './HomeForm/TrackYourStatus';

function HomeForm(){
    return(
        <div className="Form-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 home-form-fulbox">
                        <div className="home-form-heading text-center">
                            <h2 className="heading2">Receive Your Legal Entity Identifier In Hours, Not In Days!<br />The Fastest Registration Service In India</h2>
                            <ul>
                                <li><label>Legal Form *</label></li>
                                <li>
                                    <select>
                                    <option>Sole Proprietorship</option>
                                    <option>Limited Liability Partnership</option>
                                    <option>Partnership Firms</option>
                                    <option>Trusts</option>
                                    <option>Private Limited Companies</option>
                                    <option>Public Limited Companies</option>
                                    <option>Government Companies</option>
                                    <option>One Person Company</option>
                                    <option>Insurance Companies</option>
                                    <option>Housing Finance Companies</option>
                                    <option>Non-Banking Finance Companies</option>
                                    <option>Companies Limited by Guarantee</option>
                                    <option>Nonprofit companies</option>
                                    <option>Unlimited Companies</option>
                                    <option>Special Purpose Vehicle – Trust</option>
                                    <option>Special Purpose Vehicle - Partnership Firm</option>
                                    <option>Special Purpose Vehicle-Coop / Multistate Coop Societies</option>
                                    <option>Special Purpose Vehicle – Company</option>
                                    <option>Mutual Funds</option>
                                    <option>Mutual Funds-Sub Scheme</option>
                                    <option>Alternative Investment Fund (AIF)/VC Fund</option>
                                    <option>AIF - Sub scheme</option>
                                    <option>Banking Companies - Nationalized Banks</option>
                                    <option>Banking Companies - Cooperative Banks/RRBs/Payment Banks</option>
                                    <option>Banking Companies – Others</option>
                                    <option>Stand Alone Primary Dealers</option>
                                    <option>Public Financial Institutions</option>
                                    <option>Cooperative Societies or Multistate Cooperative Societies</option>
                                    <option>Government Organizations</option>
                                    <option>International Branch</option>
                                    <option>Pension Funds</option>
                                    <option>Pension Funds-Sub Scheme</option>
                                    <option>Provident fund/superannuation fund/Gratuity fund /Insurance Fund</option>
                                    <option>Others</option>

                                    </select>
                                </li>
                                <li><input  type="text" placeholder="GST / IEC / PAN" /></li>
                            </ul>
                        </div>
                        <div className='HomeTab'>
                            
                            <Tabs>
                                <TabList>
                                <Tab>Apply for a new LEI number</Tab>
                                <Tab>Modify Application</Tab>
                                <Tab>Renew an LEI number</Tab>
                                <Tab>Transfer an LEI</Tab>
                                <Tab>Track Your Status</Tab>
                                </TabList>

                                <TabPanel>
                                    <ApplyNew />
                                </TabPanel>
                                <TabPanel>
                                    <ModifyApplication />
                                </TabPanel>
                                <TabPanel>
                                    <LEIRenewal />
                                </TabPanel>
                                <TabPanel>
                                    <TransferAnLEI />
                                </TabPanel>
                                <TabPanel>
                                    <TrackYourStatus />
                                </TabPanel>
                            </Tabs>    
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    );
}
export default HomeForm